import Icon from '@ant-design/icons';

const MoonSvg = (props: any) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14 9.3866C13.3553 9.7874 12.6039 10.0178 11.8 10.0178C9.4804 10.0178 7.6 8.1374 7.6 5.8178C7.6 4.2126 8.5044 2.8166 9.8268 2.1152C9.4398 2.0396 9.0404 2 8.6312 2C5.3178 2 2.6312 4.6864 2.6312 8C2.6312 11.3138 5.3178 14 8.6312 14C11.3706 14 13.6826 12.1578 14.3688 9.6458C14.259 9.5478 14.1336 9.4602 14 9.3866Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MoonIcon = (props: any) => <Icon component={MoonSvg} {...props} />;
